export default __webpack_public_path__ + "static/media/custom-build.12a3d317.png";